import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { ISchedule } from '../../../schedule/types/ISchedule';
import { ISiteNameWithId } from '../types/ISiteNameWithId';
import { ISubscription } from '../types/ISubscription';
import { IUser } from '../types/IUser';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetSubscriptionsResult extends IGetItemsResult {
  subscriptions: ISubscription[];
  schedules: ISchedule[];
  sites: ISiteNameWithId[];
  users: IUser[];
}

export class GetSubscriptionsRequest extends Request<IGetItemsParams, IGetSubscriptionsResult> {
  constructor(params: IGetItemsParams) {
    super('getSubscriptions', params);
  }
}
